import type { FC } from 'react';

import { Skeleton } from '@/ui/components/skeleton/skeleton';

/**
 * A placeholder skeleton that mimics the table layout in OverviewTable.
 */
export const TableSkeleton: FC<{ columns: number; rows: number }> = ({
  columns,
  rows,
}) => {
  return (
    <div className="w-full space-y-2">
      {/* Table header skeleton */}
      <div className="flex justify-around bg-gray-100 py-2">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} className="h-6 w-20" />
        ))}
      </div>

      {/* Table body skeleton */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div key={rowIdx} className="flex justify-around py-2">
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Skeleton key={colIdx} className="h-4 w-20" />
          ))}
        </div>
      ))}
    </div>
  );
};
